export default {
    styleOverrides: {
        root: {
            color: "rgba(0,0,0, 0.4)"
        }
    }
}